import styled from "styled-components";
import {Select, Tabs, Typography, Table, Modal} from "antd";

const {Text} = Typography;

export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: 20px;
`;

export const TabRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin-top: 60px;
    margin-bottom: 60px;
    gap: 30px;

    @media (max-width: 992px) {
        gap: 10px;
    }

    @media (max-width: 768px) {
        flex-wrap: wrap;
        height: auto;
        gap: 10px;
    }
`;
export const CustomTab = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 178px;
    height: 160px;
    border-radius: 5px;
    text-align: center;
    padding: 4px;
    padding-top: 16px;
    padding-bottom: 16px;
    font-size: 16px;
    font-weight: ${$props => ($props.isActive ? "bold" : "normal")};

    /* Kapıda ödeme tasarımı */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    border: ${$props => ($props.isActive ? "1px solid #91d5ff" : "none")};
    background-color: ${$props => ($props.isActive ? "#e6f7ff" : "white")};

    cursor: pointer;
    transition: all 0.3s ease;

    b {
        line-height: 1.2;
    }

    img {
        width: 100%;
        max-height: 50px;
    }

    /* Tab içindeki sayı ve etiket düzeni */
    > div:last-child {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;

        > div:first-child {
            font-size: 24px;
            font-weight: bold;
            color: #000;
            line-height: 1;
        }

        > div:last-child {
            font-size: 14px;
            font-weight: 500;
            color: #666;
            line-height: 1;
        }
    }

    &:hover {
        background-color: ${$props => ($props.isActive ? "#e6f7ff" : "#f7f7f7")};
    }

    @media (min-width: 992px) and (max-width: 1440px) {
        width: 150px;
        height: 140px;
        padding: 3px;
        padding-top: 14px;
        padding-bottom: 14px;
        font-size: 15px;

        img {
            max-height: 42px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 22px;
            }
            > div:last-child {
                font-size: 13px;
            }
        }
    }

    @media (min-width: 768px) and (max-width: 992px) {
        width: 130px;
        height: 120px;
        padding: 3px;
        padding-top: 12px;
        padding-bottom: 12px;
        font-size: 14px;
        gap: 6px;

        img {
            max-height: 36px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 20px;
            }
            > div:last-child {
                font-size: 12px;
            }
        }
    }

    @media (min-width: 480px) and (max-width: 768px) {
        width: 110px;
        height: 100px;
        padding: 2px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 13px;
        gap: 4px;

        img {
            max-height: 30px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 18px;
            }
            > div:last-child {
                font-size: 11px;
            }
        }
    }

    @media (max-width: 480px) {
        width: 90px;
        height: 85px;
        padding: 2px;
        padding-top: 8px;
        padding-bottom: 8px;
        font-size: 12px;
        gap: 3px;

        img {
            max-height: 24px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 16px;
            }
            > div:last-child {
                font-size: 10px;
            }
        }
    }
`;

// Mobile responsive wrapper for CustomerOrdersTable
export const MobileResponsiveWrapper = styled.div`
    width: 100%;
    @media (max-width: 768px) {
        /* Detay butonu */
        button[data-testid="detailButton"] {
            width: 100%;
            min-width: 100px;
        }

        /* Fişi görüntüle butonu */
        .ant-btn-primary {
            font-size: 13px;
            padding: 6px 12px;
            height: auto;
        }

        /* Row gutters */
        .ant-row {
            row-gap: 8px !important;
        }

        /* Tooltip içerikleri */
        .ant-tooltip-inner {
            font-size: 13px;
        }

        /* Customer button */
        button[data-testid="readyOrderButton"] {
            font-size: 12px;
            padding: 6px 10px;
            height: auto;
            white-space: normal;
            line-height: 1.4;
        }
    }
`;

export const OrderNumber = styled(Text)`
    font-weight: bold;

    @media (max-width: 768px) {
        font-size: 16px;
        display: block;
        margin-bottom: 12px;
    }
`;

export const OrderTotalTime = styled(Text)`
    font-weight: bold;
    float: right;

    @media (max-width: 768px) {
        float: none;
        display: block;
        margin: 12px 0;
        font-size: 14px;
    }
`;

export const TableTitle = styled.h3`
    margin: 15px 0;
    font-size: 1.17em !important;

    @media (max-width: 768px) {
        margin: 12px 0;
        font-size: 1.1em !important;
    }
`;

export const TableOverflow = styled.div`
    width: 100%;
    overflow: auto;

    @media (max-width: 768px) {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
`;

export const OrderTableNew = styled(Table)`
    @media (max-width: 768px) {
        .ant-table {
            font-size: 13px;
        }

        .ant-table-thead > tr > th {
            padding: 8px;
            font-size: 12px;
        }

        .ant-table-tbody > tr > td {
            padding: 8px;
            font-size: 13px;
        }
    }
`;

export const DescriptionContainer = styled.div`
    @media (max-width: 768px) {
        .ant-descriptions-item {
            padding-bottom: 12px;
        }

        .ant-descriptions-item-label {
            font-weight: 600;
            font-size: 13px;
        }

        .ant-descriptions-item-content {
            font-size: 14px;
        }
    }
`;

export const PrepModalContainer = styled.div`
    width: 600px;
    background-color: white;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        padding: 12px;

        .ant-row {
            margin-bottom: 12px;
        }

        .ant-btn {
            font-size: 13px;
            padding: 6px 12px;
            height: auto;
        }
    }
`;

export const PrepDetailContainer = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        margin: 12px 0;
    }
`;

export const StyledPrepModal = styled(Modal)`
    @media (max-width: 768px) {
        max-width: 100% !important;
        width: 100% !important;
        margin: 0 !important;
        top: 0 !important;
        padding-bottom: 0;

        .ant-modal-content {
            border-radius: 0;
            height: 100vh;
            display: flex;
            flex-direction: column;
            max-width: 100vw;
            overflow: hidden;
        }

        .ant-modal-header {
            border-radius: 0;
            padding: 16px;
            flex-shrink: 0;
        }

        .ant-modal-body {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 12px;
            max-width: 100vw;
            box-sizing: border-box;
        }

        .ant-modal-close {
            top: 16px;
            right: 16px;
            width: 40px;
            height: 40px;

            .ant-modal-close-x {
                width: 40px;
                height: 40px;
                line-height: 40px;
                font-size: 18px;
            }
        }

        .ant-table-wrapper {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
`;
